(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bash-cart-footer-mock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bash-cart-footer-mock')) {
  customElements.define('bash-cart-footer-mock', class BashCartFooterMock extends HTMLElement {
    connectedCallback() {
      if (this._events) return;
      this._review = new URL(window.location.href).searchParams.get('footer_mock') === '1';
      if (!this._review && this.dataset.enabled !== 'true') return;
      this.hidden = !this._review;
      this.dataset.active = 'true';
      this._notes = new Map();
      this._metas = new Map();
      this._labels = new Map();
      this._events = new AbortController();
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-footer-layout]');
        if (!button || !this.contains(button)) return;
        this._setLayout(button.dataset.footerLayout);
        this._openDrawer(button);
      }, { signal: this._events.signal });
      this._observer = new MutationObserver((records) => {
        const changed = records.some((record) => {
          const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          return target?.closest('cart-drawer') || Array.from(record.addedNodes).some((node) =>
            node.nodeType === 1 && (node.matches('cart-drawer') || node.querySelector('cart-drawer'))
          );
        });
        if (changed) this._queue();
      });
      this._observer.observe(document.body, { childList: true, subtree: true });
      this._setLayout('slim');
      if (this._review) this._openDrawer(this.querySelector('[data-footer-layout="slim"]'));
    }

    disconnectedCallback() {
      if (!this._events) return;
      this._events.abort();
      this._events = null;
      this._observer.disconnect();
      if (this._frame) cancelAnimationFrame(this._frame);
      this._frame = 0;
      this._restore();
      this.removeAttribute('data-active');
    }

    _openDrawer(button) {
      requestAnimationFrame(() => {
        if (!this.isConnected) return;
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open(button);
      });
    }

    _setLayout(layout) {
      if (!['current', 'slim'].includes(layout)) return;
      this.dataset.layout = layout;
      this.querySelectorAll('button[data-footer-layout]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.footerLayout === layout));
      });
      if (layout === 'slim') this._decorate();
      else this._restore();
    }

    _queue() {
      if (this._frame || this.dataset.layout !== 'slim') return;
      this._frame = requestAnimationFrame(() => {
        this._frame = 0;
        if (this.isConnected && this.dataset.layout === 'slim') this._decorate();
      });
    }

    _decorate() {
      const footer = document.querySelector('cart-drawer #CartDrawer .drawer__footer');
      if (!footer) return;
      for (const [notice] of this._notes) if (!notice.isConnected) this._notes.delete(notice);
      for (const [meta] of this._metas) if (!meta.isConnected) this._metas.delete(meta);
      for (const [label] of this._labels) if (!label.isConnected) this._labels.delete(label);

      footer.querySelectorAll('.custom-shipping-calc').forEach((calc) => {
        const meta = calc.querySelector('.bash-ship-meta');
        const main = calc.querySelector('.calc-main-header');
        if (!meta || !main || this._metas.has(meta)) return;
        this._metas.set(meta, { parent: meta.parentNode, next: meta.nextSibling });
        main.appendChild(meta);
      });

      if (this.dataset.collapseDuties !== 'false') {
        footer.querySelectorAll('.bash-cart-import-notice').forEach((notice) => {
          if (this._notes.has(notice)) return;
          const heading = notice.querySelector(':scope > strong');
          if (!heading) return;
          const original = Array.from(notice.childNodes);
          const details = document.createElement('details');
          const summary = document.createElement('summary');
          const body = document.createElement('div');
          details.className = 'bt-footer-duties';
          summary.className = 'bt-footer-duties__summary';
          body.className = 'bt-footer-duties__body';
          summary.appendChild(heading);
          original.forEach((node) => { if (node !== heading) body.appendChild(node); });
          details.append(summary, body);
          notice.appendChild(details);
          this._notes.set(notice, { original, details });
        });
      }

      footer.querySelectorAll('.bash-payment-methods__label').forEach((label) => {
        if (this._labels.has(label) || !this.dataset.paymentLabel) return;
        this._labels.set(label, label.textContent);
        label.textContent = this.dataset.paymentLabel;
      });
    }

    _restore() {
      for (const [notice, entry] of this._notes) {
        if (notice.isConnected && entry.details.parentNode === notice) {
          entry.details.replaceWith(...entry.original);
        }
      }
      for (const [meta, entry] of this._metas) {
        if (meta.isConnected && entry.parent.isConnected) {
          entry.parent.insertBefore(meta, entry.next?.parentNode === entry.parent ? entry.next : null);
        }
      }
      for (const [label, original] of this._labels) {
        if (label.isConnected && label.textContent === this.dataset.paymentLabel) label.textContent = original;
      }
      this._notes.clear();
      this._metas.clear();
      this._labels.clear();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
